/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["text-controls-drawer .mat-button-toggle-group{margin-right:15px}text-controls-drawer text-font-selector{line-height:48px}"];
export { styles as styles };
